<template>
    <Head><title>AI Data Sharing</title></Head>
    <div class="flex flex-col min-h-screen overflow-y-auto h-screen bg-valence-neutral-light text-valence-grey-800 safe-area-top">
        <div class="fade-in grow justify-center gap-5 md:gap-8 flex flex-col items-center py-4 md:py-10">
            <div class="flex flex-col gap-4 justify-around text-center max-w-sm mx-auto px-4">
                <div class="flex flex-col pb-5 justify-center">
                    <img :src="Logo" alt="Valence logo" class="mx-auto h-16 w-auto" />
                </div>
            </div>
            <div class="flex flex-col gap-4 items-center max-w-md w-full px-4">
                <div class="text-center mb-2">
                    <h2 class="title-body mb-2">How Nadia uses AI</h2>
                    <p class="body-small text-gray-600">Please review and accept to continue.</p>
                </div>

                <div class="leading-normal max-h-80 overflow-y-auto text-left rounded-lg px-4 py-4 bg-[#f5f5f5] ring-2 ring-inset ring-[#e8e8e8]">
                    <MarkdownText class="*:body *:text-valence-grey-750 [&_p+p]:mt-3 [&_a]:underline" :text="disclosure_content" />
                </div>

                <BaseCheckbox v-model="consent" shape="square" class="body-small text-valence-grey-750 justify-center">
                    I understand and agree that my data will be shared with these third-party AI providers.
                </BaseCheckbox>

                <p v-if="error" class="text-error font-medium">{{ error.message }}</p>
                <LoadingSpinner v-if="isFetching" class="w-10 h-10" />
                <BaseButton v-else theme="primary" data-testid="ai-consent-continue" class="w-full py-4 rounded-xl font-semibold" :disabled="!consent" @click="acceptConsent">
                    Continue
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Head } from "@inertiajs/vue3";
import Logo from "~img/color-logo.svg";
import { useFetch } from "~vue/api";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCheckbox from "~vue/components/form/BaseCheckbox.vue";
import { useStatusBar } from "~vue/composables/useStatusBar";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import MarkdownText from "~vue/MarkdownText.vue";
import { ref } from "vue";

useStatusBar();

const props = defineProps({
    next_url: { type: String, default: "/" },
    disclosure_content: { type: String, default: "" },
    terms_document_id: { type: String, required: true },
});

const consent = ref(false);

const { data, error, execute, isFetching } = useFetch("/accounts/ai-consent/", { immediate: false })
    .post(() => ({ consent: consent.value, terms_document_id: props.terms_document_id, next: props.next_url }))
    .json();

async function acceptConsent() {
    if (!consent.value) {
        return;
    }
    await execute();
    if (!error.value) {
        globalThis.location.href = data.value?.redirect ?? props.next_url;
    }
}
</script>
